<!-- 任务点排名 -->
<template>
  <div>
    <a-card v-show="loading" :loading="loading"><span /> </a-card>
    <a-card v-show="!loading" size="small" :bordered="false">
      <template slot="title">
        <span style="margin-right: 4px">价值追溯分布</span>
        <a-popover title="报表说明" placement="topLeft">
          <template slot="content">
            <p>业务需求价值追溯分布</p>
          </template>
          <a-icon type="question-circle" />
        </a-popover>
      </template>
      <div slot="extra">
        <a-radio-group v-model="showModal" button-style="solid" size="small" @change="changeData">
          <a-radio-button value="bar"> 柱状图 </a-radio-button>
          <a-radio-button value="pie"> 圆饼图 </a-radio-button>
        </a-radio-group>
      </div>
      <div ref="countRef" :style="{ height: height, width: width }" />
    </a-card>
    <BusinessRequirementListModal ref="businessRequirementListModalRef" />
  </div>
</template>
<script>
import BusinessRequirementListModal from '@/pages/business/requirement/components/BusinessRequirementListModal';
const echarts = require('echarts/lib/echarts');
export default {
  components: { BusinessRequirementListModal },
  props: {
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '350px'
    },
    datas: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data() {
    return {
      tableData: [],
      showModal: 'bar',
      loading: false,
      myChart: null,
      // 柱状图配置
      optionBar: {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        grid: {
          left: '2%',
          right: '3%',
          bottom: '16%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: [],
          // axisLabel: {
          //   interval: 0,
          //   rotate: 45
          // },
          axisLabel: {
            interval: 0,
            formatter: function (value) {
              // 如果标签长度超过4，将剩余的文字替换为省略号
              value = value.replace('MRD', '');
              if (value.length > 5) {
                return value.slice(0, 5) + '...';
              } else {
                return value;
              }
            }
          }
        },
        legend: {},
        yAxis: {},
        series: [],
        dataZoom: [
          {
            show: true,
            realtime: true,
            button: 0,
            height: 18,
            endValue: 18
          }
        ]
      },
      optionPie: {
        tooltip: {
          trigger: 'item'
        },
        legend: {
          top: '5%',
          left: 'center',
          show: false
        },
        series: [
          {
            name: '需求总数',
            type: 'pie',
            radius: '60%',
            center: ['50%', '50%'],
            data: [],
            label: {
              formatter: '{b} ({d}%)',
              fontSize: 12
            },
            emphasis: {
              label: {
                show: true,
                fontWeight: 'bold'
              }
            }
          }
        ]
      },
      data: []
    };
  },
  watch: {
    datas: {
      handler(val) {
        this.tableData = val || [];
        this.changeData(this.tableData);
      },
      immediate: false,
      deep: true
    },
    '$store.state.collapsed'() {
      setTimeout(() => {
        this.myChart.resize();
      }, 200);
    }
  },
  mounted() {
    // let echarts = require('echarts');
    // const echarts = require('echarts/lib/echarts');
    require('echarts/lib/chart/bar'); // 柱状图
    require('echarts/lib/chart/pie'); // 饼图
    require('echarts/lib/chart/line');
    // 下面的是需要的提示框
    require('echarts/lib/component/tooltip');
    require('echarts/lib/component/legend');
    require('echarts/lib/component/grid');
    require('echarts/lib/component/dataZoom');
    require('echarts/lib/component/markLine');
    this.myChart = echarts.init(this.$refs.countRef);
    // 柱状图-点击事件
    this.myChart.on('click', params => {
      // 打印当前点击柱状的数据
      const statuObj = this.$store.getters.getGlobalBusinessStatus();
      const values = Object.values(statuObj);
      for (const key in statuObj) {
        const obj = statuObj[key];
        if (obj.title === params.name) {
          this.$refs.businessRequirementListModalRef.open(params.name, { statusList: [key] });
          return;
        }
      }
    });
    this.changeData();
  },
  beforeDestroy() {
    // 页面组件销毁的时候，移除绑定的监听resize事件，防止内存泄漏和额外CPU或GPU占用
    window.removeEventListener('resize', () => {
      this.myChart.resize();
    });
  },
  methods: {
    setData(val) {
      this.tableData = val || [];
      this.changeData();
    },
    changeType() {},
    drawChart() {
      if (this.showModal === 'bar') {
        this.myChart.setOption(this.optionBar, true);
      } else {
        this.myChart.setOption(this.optionPie, true);
      }
      this.$nextTick(() => {
        this.myChart.resize();
      });
    },
    changeData() {
      const titles = ['无需追溯', '暂未追溯', '逾期未追溯', '已完成追溯:符合预期', '已完成追溯:不符合预期', '逾期完成追溯:符合预期', '逾期完成追溯:不符合预期'];
      if (this.showModal === 'bar') {
        const x_axis = titles;
        const yDataList = [];
        for (const key of titles) {
          const d = this.tableData.filter(it => it.retrospectValueName + '' === key + '');
          if (d) {
            yDataList.push(d.length);
          } else {
            yDataList.push(0);
          }
        }

        this.optionBar.xAxis.data = x_axis;
        this.optionBar.series = [
          {
            type: 'bar',
            label: {
              show: true,
              position: 'top'
            },
            name: '需求个数',
            data: yDataList,
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#83bff6' },
                { offset: 0.5, color: '#188df0' },
                { offset: 1, color: '#188df0' }
              ])
            }
          }
        ];
      } else {
        const dataList = [];
        for (const key of titles) {
          // console.log(key + ': ' + statuObj[key].title);
          const d = this.tableData.filter(it => it.retrospectValueName + '' === key + '');
          if (d) {
            dataList.push({
              value: d.length,
              name: key
            });
          } else {
            dataList.push({
              value: 0,
              name: key
            });
          }
        }
        this.optionPie.series[0].data = dataList;
      }
      this.drawChart();
    }
  }
};
</script>

<style lang="less" scoped>
.customer-card {
  margin-bottom: 10px;
}
/deep/.ant-card-small > .ant-card-body {
  padding: 0;
}
</style>
